import { DEFECT_POSITION, DEFECT_SEVERITY } from "../../Checks/constants";
import { FormCheckboxManagedField, FormFruitImagesField, FormNumberField, FormRadioField } from "./constantsTyped";

export const pressure: FormNumberField = {
    label: "Pressure",
    name: "pressure",
    type: "number",
    mandatory: false,
    min: 0,
    max: 100,
    unity: "LBS",
    lg: 3
};

export const weight: FormNumberField = {
    label: "Weight",
    name: "weight",
    type: "number",
    mandatory: false,
    min: 0,
    max: 9999,
    unity: "GR",
    lg: 3
};

export const taste: FormRadioField = {
    label: "Taste",
    name: "manual_taste",
    type: "radio",
    options: [
        { text: "Balanced", value: "balanced" },
        { text: "Sweet", value: "sweet" },
    ],
};

export const internal_color: FormRadioField = {
    label: "Internal Color",
    name: "manual_internal_color_stage",
    type: "radio",
    options: [
        { text: "1", value: 1, color: "#f8d37a", className: "me-3 text-white" },
        { text: "2", value: 2, color: "#f0d35b", className: "me-3 text-white" },
        { text: "3", value: 3, color: "#e7bf43", className: "me-3 text-white" },
        { text: "4", value: 4, color: "#f6b041", className: "me-3 text-white" },
        { text: "5", value: 5, color: "#f19940", className: "me-3 text-white" },
    ],
    mandatory: true
};

export const defects: FormCheckboxManagedField = {
    label: "Defects",
    name: "defects",
    type: "checkbox-managed",
    defect_position: Object.values(DEFECT_POSITION),
    defect_severity: Object.values(DEFECT_SEVERITY)

};

export const maturity: FormRadioField = {
    label: "Maturity",
    name: "manual_maturity",
    type: "radio",
    options: [
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "2.5", value: "2.5" },
        { label: "3", value: "3" },
        { label: "4", value: "4" },
        { label: "5", value: "5" },
    ],
    mandatory: true
};

export const brix: FormNumberField = {
    label: "Brix",
    name: "manual_brix",
    type: "number",
    min: 0,
    max: 100,
    unity: "%",
    lg: 3
};


export const temperature: FormNumberField = {
    label: "Temperature",
    name: "manual_temperature",
    type: "number",
    mandatory: false,
    min: -100,
    max: 100,
    unity: "°C",
    lg: 3
};

export const fruit_images: FormFruitImagesField = {
    label: "Fruit Images",
    name: "fruit_images",
    type: "fruit-images",
};

export const fruit_diameter: FormNumberField = {
    label: "Diameter",
    name: "fruit_diameter",
    type: "number",
    mandatory: false,
    min: 0,
    unity: "mm",
    lg: 3
};

export const fruitFormField = [
    defects,
    maturity,
    pressure,
    taste,
    internal_color,
    brix,
    weight,
    temperature,
    fruit_images,
    fruit_diameter
];


